import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs';
import { IContext } from '../../context/models/context';
import { DiaryEvent } from '../models/diary-event';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { SaveDiaryConfigurationRequest, DiaryConfiguration } from '@diary/models/diary-configuration';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class DiaryEventsHttpService {

  constructor(private readonly urlProvider: UrlBuilderService,
              private http: HttpClient) { }

  private mapResponse(diaryEvent: DiaryEvent): DiaryEvent {
    diaryEvent.EventDate = diaryEvent.EventDate ? new Date(diaryEvent.EventDate) : diaryEvent.EventDate;
    diaryEvent.BringForwardDate = diaryEvent.BringForwardDate ? new Date(diaryEvent.BringForwardDate) : diaryEvent.BringForwardDate;
    diaryEvent.NoticeDate = diaryEvent.NoticeDate ? new Date(diaryEvent.NoticeDate) : diaryEvent.NoticeDate;
    diaryEvent.DiaryDate = diaryEvent.DiaryDate ? new Date(diaryEvent.DiaryDate) : diaryEvent.DiaryDate;
    return diaryEvent;
  }

  getDiaryEvents(context: IContext, startDate: Date, endDate: Date, widgetId: number): Observable<DiaryEvent[]> {
    const vacantsUrl =  this.urlProvider.getUrl('diaryevents');
    const paramterData = { context: context, startDate: startDate, endDate: endDate, widgetId: widgetId };

    return this.http
      .post<DiaryEvent[]>(vacantsUrl, paramterData).pipe(
        map(data => (data || []).map((value) => {
          return this.mapResponse(value);
        }))
      );
  }

  getUndatedDiaryEvents(context: IContext): Observable<DiaryEvent[]> {
    const url = this.urlProvider.getUrl('undatedDiaryEvents');

    return this.http
      .post<DiaryEvent[]>(url, context).pipe(
        map(events => events || undefined)
      );
  }

  getWidgetConfiguration(widgetConfigurationId: number) {
      const url = this.urlProvider.getUrl(`diaryevents/config/${widgetConfigurationId}`);
      return this.http.get<DiaryConfiguration>(url);
    }

    copyWidgetConfiguration(request: SaveDiaryConfigurationRequest) {
      const url = this.urlProvider.getUrl('diaryevents/config/copy');
      return this.http.post(url, request).pipe(mapTo(true));
    }

    saveWidgetConfiguration(request: SaveDiaryConfigurationRequest) {
      const url = this.urlProvider.getUrl('diaryevents/config');
      return this.http.post(url, request).pipe(mapTo(true));
    }
}
